import { render } from "./DataTableFooter.vue?vue&type=template&id=747a3c82"
import script from "./DataTableFooter.vue?vue&type=script&lang=js"
export * from "./DataTableFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__